module.exports = __webpack_public_path__ + "img/dy_erweima.32266f17.jpg";